/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cas_Action_Edit_VisibilityInputs */

const en_cas_action_edit_visibility = /** @type {(inputs: Cas_Action_Edit_VisibilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit visibility`)
};

/**
* | output |
* | --- |
* | "Edit visibility" |
*
* @param {Cas_Action_Edit_VisibilityInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const cas_action_edit_visibility = /** @type {((inputs?: Cas_Action_Edit_VisibilityInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cas_Action_Edit_VisibilityInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cas_action_edit_visibility(inputs)
});